import { ElementType, IElement } from "../../../models/Element";
import { ElementHeaderType } from "../../utils";

export const defaultThreeRowData: string[] = [
  "Belminuten onderling/platform",
  "Gratis",
  "Gratis",
];

export type TableThreeColumns = IElement & {
  header: string;
  header_type: ElementHeaderType;
  tableHeads: string[];
  dataTable: string[][];
  content: string;
};

export const defaultTableThreeColumns: TableThreeColumns = {
  id: 0,
  name: ElementType.TABLE_THREE_COLUMNS,
  header: "Gesprekstarieven VoIP",
  header_type: ElementHeaderType.H2,
  tableHeads: ["Type gesprek", "Tarief p/m", "Starttarief"],
  dataTable: [
    ["Belminuten onderling/platform", "Gratis", "Gratis"],
    ["Vaste nummers binnenland", "€ 0,021", "€ 0,029"],
  ],
  content:
    "Optionele tekst. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
};
